module.exports = __webpack_public_path__ + "static/media/media.6c16ec03.svg";